import * as FilePond from "filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import EN from "filepond/locale/en-en";
import DE from "filepond/locale/de-de";
import "@cap.js/widget";

import "filepond/dist/filepond.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

FilePond.registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateSize, FilePondPluginFileValidateType);

const lang = document.querySelector("html").getAttribute("lang");
if (lang == "de") {
    FilePond.setOptions(DE);
} else {
    FilePond.setOptions(EN);
}

window.addEventListener("load", () => {
    const el = document.querySelector("input.filepond");
    if (el) {
        FilePond.create(el, {
            storeAsFile: true,
            credits: false,
            maxFileSize: "20MB",
            maxTotalFileSize: "50MB",
            maxFiles: 10,
            allowReorder: true,
        });
    }

    const cap = document.querySelector("#cap");
    if (cap) {
        cap.addEventListener("solve", e => {
            const token = e["detail"]["token"];
            const input = <HTMLInputElement>document.querySelector("input[name=CaptchaToken]");
            input.value = token;
        });
    }
});
